export default "__VITE_ASSET__mHJM9j6f__"